export const LIST_FILTERS = {
    'Locations': {
        checks: [
            {filter_name: 'filter_company', data_name: 'company_id'},
            {filter_name: 'filter_dba', data_name: 'dba_id'},
            {filter_name: 'filter_district', data_name: 'district_id'},
            {filter_name: 'filter_id', data_name: 'id'},
            {filter_name: 'filter_state', data_name: 'state'}
        ]
    },
    'POSUsers': {
        checks:
            [
                {filter_name: 'filter_location', data_name: 'location_id'}
            ]
    },
    'ProductAliases': {
        checks: [
            {filter_name: 'type', data_name: 'type'},
            {filter_name: 'unit_type', data_name: 'unit_type'}
        ]
    },
    'ProductCategories': {
        checks: [
            {filter_name: 'type', data_name: 'type'}
        ]
    },
    'Products': {
        checks: [
            {filter_name: 'category_id', data_name: 'category_id'},
            {filter_name: 'type', data_name: 'type'}
        ]
    }
};



// WEBPACK FOOTER //
// ./src/Fuse/shared/filterLists.js